export default "__VITE_ASSET__B1oGDHU0__"